import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {ConfService} from '../../../conf.service';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-add-new-gateway-new',
  templateUrl: './add-new-gateway-new.component.html',
  styleUrls: ['./add-new-gateway-new.component.scss']
})
export class AddNewGatewayNewComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AddNewGatewayNewComponent>, public confPost: ConfService, @Inject(MAT_DIALOG_DATA) public data: any) {
    dialogRef.disableClose = true;
  }
  APIGateways = [
    {
      gateway: 'apiplatform',
      image: './assets/img/partnerOnboarding/api.png',
      description: 'Default',
      value: 'default'
    },
    {
      gateway: 'Kong',
      image: './assets/img/kong.png',
      description: 'Kong',
      value: 'kong'
    },
    {
      gateway: 'Google',
      image: './assets/img/partnerOnboarding/apigee.png',
      description: 'APIGEE',
      value: 'apigee'
    },
    {
      gateway: 'Microsoft',
      image: './assets/img/partnerOnboarding/azure.png',
      description: 'Azure',
      value: 'azure'
    },
    {
      gateway: 'Amazon',
      image: './assets/img/partnerOnboarding/awsGateway.png',
      description: 'AWS API Gateway',
      value: 'aws'
    }
  ];
  connectionDetailsKongSchema = {
  };
  connectionDetailsSchema = {
    'name': '',
    'provider': '',
    'gatewayConfigurations': '',
    'url': '',
    'audit_log': []
  };
  connectionDetailsKong = ['Name', 'Url'];
  selectedGateway: any;
  connectionDetails: any;
  cloudConfig: any;
  ngOnInit(): void {
    const time = new Date();
    this.cloudConfig = this.data.payload;
  }
  addNewConnection() {
    if (this.selectedGateway === undefined) {
      alert('Please select a gateway to continue adding connection');
    } else {
      this.dialogRef.close(this.connectionDetailsSchema);
    }
  }
  close() {
    this.dialogRef.close();
  }
  selectGateway(index) {
    this.selectedGateway = this.APIGateways[index];
    if (this.selectedGateway.value !== 'default') {
      this.connectionDetails = this.connectionDetailsKong;
      this.connectionDetailsSchema.provider = this.selectedGateway.value;
    } else {
      this.connectionDetails = [];
      this.connectionDetailsSchema.provider = this.selectedGateway.value;
    }
    for (let i = 0; i < this.APIGateways.length; i++) {
      const id = 'selectedGateway' + i;
      if (index === i) {
        $('#' + id).css('border', '2px solid #ff672d');
      } else {
        $('#' + id).css('border', 'transparent');
      }
    }
  }

}
